import React from "react";
import DataGrid from "../../Component/DataGrid/DataGrid";
import { TableColumn } from 'react-data-table-component';

export interface IUserDetails {
    user_id: string;
    name: string;
    email: string;
    mobile_number: string;
    user_status_id: number;
    address_line1: string;
    address_line2: string;
    city: string;
    state: string;
    zip: string;
}

interface UserDetailsProps {
    data: IUserDetails[];
}

class TransactionDetails extends React.Component<UserDetailsProps> {
    private tableColumns: TableColumn<IUserDetails>[] = [
        {
            name: 'Address Line 1',
            selector: row => row.address_line1,
            sortable: false,
            id: "AccountName",

        },
        {
            name: 'Address Line 2',
            selector: row => row.address_line2,
            sortable: false,
            id: "AccountNumber",

        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: false,
            id: "BillerName"
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            id: "Channel"
        },
        {
            name: 'Zip',
            selector: row => row.zip,
            sortable: false,
            id: "sendercurrency"
        },
    ]

    constructor(props_: UserDetailsProps) {
        super(props_);
    }

    public render() {
        return (
            <div className="details-container">
                <DataGrid
                    gridId="UserAddress"
                    columns={this.tableColumns}
                    data={this.props.data}
                    expandableRows={false}
                    pagination={false}
                    useExternalTriggerForColumsMenu={false}
                />
            </div>
        )
    }
}

export default TransactionDetails;